import {REQUEST_ORDERS, REQUEST_ORDERS_FAILURE, REQUEST_ORDERS_SUCCESS} from "../../../constant/transaction/OrderConstant";

const initialState = {
    orders: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const ordersReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_ORDERS:
            return {
                ...state,
                orders: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_ORDERS_SUCCESS:
            return {
                ...state,
                orders: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_ORDERS_FAILURE:
            return {
                ...state,
                orders: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
